import { getPatientList } from '@/api/misc.js'
import isEqual from 'lodash.isequal'

const getDefaultState = () => (
  {
    loading: {
      status: false,
      time: null,
      orgData: null
    },
    normalList: [],
    pendingList: [],
    completeList: []
  }
)

const state = getDefaultState()

const getters = {
  getNormalList: state => {
    return state.normalList
  },
  getPendingList: state => {
    return state.pendingList
  },
  getCompleteList: state => {
    return state.completeList
  },
  getAllPatientList: state => {
    const { normalList, pendingList, completeList } = state
    return [...normalList, ...pendingList, ...completeList]
  },
  getDefaultPatientId: state => {
    return getDefaultPatientId(state.normalList, state.pendingList, state.completeList)
  },
  getLoadingStatus: state => {
    return state.loading.status
  },
  getLoadingTime: state => {
    return state.loading.time
  }
}

const mutations = {
  SET_LOADING_INFO: (state, { status = false, time = new Date().getTime(), orgData = null }) => {
    state.loading.status = status
    state.loading.time = time
    state.loading.orgData = orgData
  },
  SET_NORMAL_LIST: (state, object) => {
    if (!object) return
    let normalList = []
    for (let key of Object.keys(object)) {
      normalList.push(buildUserObject(object, key))
    }
    state.normalList = normalList.sort(sortByTime)
  },
  SET_PENDING_LIST: (state, object) => {
    if (!object) return
    let pendingList = []
    for (let key of Object.keys(object)) {
      pendingList.push(buildUserObject(object, key))
    }
    state.pendingList = pendingList.sort(sortByTime)
  },
  SET_COMPLETE_LIST: (state, object) => {
    if (!object) return
    let completeList = []
    for (let key of Object.keys(object)) {
      // NOTE: 前端先給 已結束的病人 type (後端為空)，用來判斷病人的 status
      let patient = buildUserObject(object, key)
      if (patient.object.isRental) {
        const now = new Date().getTime()
        const isLeaseExpired = patient.object.endTime - now <= 0
        // NOTE: 如果是租用未到期，被結束計畫應該顯示計畫已結束
        if (isLeaseExpired) {
          patient.type = 'LEASE_EXPIRED'
        } else {
          patient.type = 'PROJECT_COMPLETED'
        }
      } else {
        patient.type = 'PROJECT_COMPLETED'
      }
      completeList.push(patient)
    }
    state.completeList = completeList.sort(sortByTime)
  },
  SET_USER_FROM_PENDING_TO_NORMAL: (state, id) => {
    const patientIndex = state.pendingList.findIndex(v => v.id === id)
    if (patientIndex > -1) {
      // 從 pending list 中刪除變更狀態的病人
      const [ patientObj ] = state.pendingList.splice(patientIndex, 1)
      delete patientObj.status

      // 加入 normal list
      state.normalList.unshift(patientObj)
    }
  },
  // 重置 state
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  }
}

const actions = {
  getPatientList ({ commit, state }) {
    return new Promise((resolve, reject) => {
      getPatientList()
        .then(response => {
          const { normal = null, todo = null, complete = null } = response.data

          if (!response.data) {
            reject(new Error('[CZN error]: Patient list API has no data !!'))
          }

          // 如果已經掉用過 api ，檢查 待處理列表(todo) 是否相同  不同 -> resetHomeMessages
          if (state.loading.status) {
            const { orgData } = state.loading
            if (!isEqual(todo, orgData.todo)) {
              commit('main/resetHomeMessages', null, { root: true })
            }
          }

          commit('SET_NORMAL_LIST', normal)
          commit('SET_PENDING_LIST', todo)
          commit('SET_COMPLETE_LIST', complete)
          commit('SET_LOADING_INFO', { status: true, orgData: response.data })

          resolve()
        })
        .catch(error => reject(error))
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

// 獲取初次進入病患管理的病人ID， 進行中病人 -> 待處理 -> 已結束
function getDefaultPatientId (normalList, pendingList, completeList) {
  const [ firstNormalListPatient ] = normalList
  const [ firstPendingListPatient ] = pendingList
  const [ firstCompleteListPatient ] = completeList
  if (firstNormalListPatient) return firstNormalListPatient.id
  if (firstPendingListPatient) return firstPendingListPatient.id
  if (firstCompleteListPatient) return firstCompleteListPatient.id
  return ''
}

function buildUserObject (object, key) {
  return {
    id: key,
    name: object[key].from,
    avatar: object[key].avatar,
    object: object[key].object,
    type: object[key].type || '',
    time: object[key].time || 0
  }
}

function sortByTime (a, b) {
  if (b.time < a.time) {
    return -1
  } else if (b.time > a.time) {
    return 1
  }

  return 0
}



// WEBPACK FOOTER //
// ./src/stores/modules/patientList.js